import React, { useEffect, useMemo } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import moment from 'moment-timezone'
import { constants } from 'helpers'
// import { useEventReadyCheck } from 'hooks'
import Button from 'components/Button'
import PrimaryButton from 'components/PrimaryButton'
import RightArrowIcon from 'components/RightArrowIcon'
import VideoCameraIcon from 'components/VideoCameraIcon'
import LiveNow from './LiveNow'
import InfoCta from './InfoCta'

const {
  EVENT_CONSTANTS: { STATUS, PREP_BUFFER_MINUTES },
} = constants

const newEventView = true

const missingPermissions = []

const CallToAction = ({ onEnterEvent, event, lg }) => {
  // const { missingPermissions } = useEventReadyCheck()

  const eventState = useMemo(() => {
    const hasEventStarted = event.status === STATUS.STARTED
    const isPreEvent = [STATUS.PENDING, STATUS.CREATED, STATUS.UPDATED].includes(event.status)
    const isEventActive = hasEventStarted || isPreEvent
    const isEventLive =
      hasEventStarted ||
      (isPreEvent &&
        moment().isAfter(
          moment(event.startTime).subtract(PREP_BUFFER_MINUTES, 'minute'),
          'seconds'
        ))

    return {
      hasEventStarted,
      isEventLive,
      isEventActive,
      isPreEvent,
    }
  }, [event])

  useEffect(() => {}, [event])

  return (
    <div className="flex mt-6 flex-wrap flex-col flex-col-reverse lg:items-end lg:justify-end xl:items-center xl:flex-row xl:flex-nowrap xl:justify-start">
      {newEventView ? (
        <Button
          className="h-12 w-full text-sm bg-white bg-opacity-10 lg:h-16 lg:w-52 xl:mr-12"
          onClick={e => {
            e.preventDefault()
            onEnterEvent(event.id)
          }}
        >
          <div className="flex items-center">
            <RightArrowIcon className="w-4 h-4 mr-2 opacity-30" />
            <span>More details</span>
          </div>
        </Button>
      ) : (
        <>
          {eventState.isEventActive && (
            <PrimaryButton
              data-eventbuttonid={event.id}
              className={classnames('h-12 w-full text-sm lg:h-16 lg:w-52 xl:mr-12')}
              style={{
                background: eventState.isEventLive
                  ? 'linear-gradient(100.11deg, #AF32B2 -29.95%, #C0572A 140.99%)'
                  : 'rgba(255, 255, 255, 0.1',
              }}
              onClick={e => {
                // prevents the click event from bubbling up to the event card link
                e.preventDefault()
                onEnterEvent(event.id)
              }}
            >
              {eventState.isEventLive ? (
                'Enter Event'
              ) : (
                <div
                  className={classnames('flex items-center  w-full', {
                    'justify-between': missingPermissions.length,
                    'justify-center': !missingPermissions.length,
                  })}
                >
                  {missingPermissions.length ? (
                    <>
                      <div>
                        <VideoCameraIcon className="w-4 w-4 opacity-50 mr-2" />
                        <span className="text-sm">Connect</span>
                      </div>
                      <div className="flex justify-center items-center bg-red-500 rounded-full w-5 h-5 align-middle text-xs">
                        {missingPermissions.length}
                      </div>
                    </>
                  ) : (
                    <div className="flex items-center">
                      <RightArrowIcon className="w-4 h-4 mr-2 opacity-30" />
                      <span>Join Lobby</span>
                    </div>
                  )}
                </div>
              )}
            </PrimaryButton>
          )}

          {eventState.isEventLive ? (
            <LiveNow />
          ) : (
            lg && (
              <Link className="hidden" to={`/events/${event.id}`}>
                <InfoCta
                  Icon={RightArrowIcon}
                  text="View Info"
                  hideBorder={!eventState.isPreEvent}
                />
              </Link>
            )
          )}
        </>
      )}
    </div>
  )
}

CallToAction.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.number,
    status: PropTypes.string,
  }),
  onEnterEvent: PropTypes.func,
  lg: PropTypes.bool,
}

export default CallToAction
